import axiosUtil from "../utils/axiosUtil"
import { PER_PAGE } from "../components/variables/variables"

const articlesApi = {
    getArticlesBySection: async ({ perPage, page, sectionId }) => {
        try {

            const result = await axiosUtil.get(`/articles/sections/${sectionId}`, {
                perPage: (!perPage || perPage <= 0) ? PER_PAGE : perPage,
                page: (!page || page <= 0) ? 1 : page,
            })
            return result;
        } catch (error) {
            console.error(error);
        }
    },
    getArticleSuggestionsForSearch: async (searchString) => {
        try {
            const result = await axiosUtil.get('/articles/suggestions', {searchString})
            return result.data
        } catch (error) {
            return {status: false}
        }
    },
    getArticlesByServiceType: async ({ perPage, page, serviceType, status, tripId, sectionId }) => {
        try {
            const result = await axiosUtil.get('/articles', {
                serviceType,
                status,
                perPage: (!perPage || perPage <= 0) ? PER_PAGE : perPage,
                page: (!page || page <= 0) ? 1 : page,
                tripId: tripId || '',
                sectionId: sectionId || ''
            })

            return result;
        } catch (error) {
            console.error(error);
        }
    },
    getArticle: async (articleId, tripId) => {
        try {
            const result = await axiosUtil.get(`/articles/${articleId}`, {
                tripId: tripId
            })
            return result;
        } catch (error) {
            console.error(error);
        }
    }
}

export default articlesApi;
